import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const contractorsTable = async (query, page = 1, pageSize = 10) => {
  return await httpClient.get(
    `/ct_certification_resume/?page[number]=${page}&page[size]=${pageSize}`,
    makeFilterParams(query),
  );
};

const contractsTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certification_contract/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certification_contract/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const getContractor = async (id) => {
  return await httpClient.get(`/ct_certification_resume/${id}`);
};

const getContractDetails = async (id) => {
  return await httpClient.get(`/ct_certification_contract/${id}`);
};

const certificatesTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certifications/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certifications/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const post = async (data) => {
  return await httpClient.post('/ct_certifications/', data);
};

const get = async (id) => {
  return await httpClient.get(`/ct_certifications/${id}`);
};

const generalCertificatesTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certification_general/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certification_general/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const generalCertificatesOrganizations = async (tercero_id) => {
  return await httpClient.get(
    '/ct_general_certification_contract/organizations/',
    {
      params: {
        'filter[tercero]': tercero_id,
      },
    },
  );
};

const generalCertificatesContractTable = async (
  query,
  page = 1,
  pageSize = 10,
) => {
  return await httpClient.get(
    `/ct_general_certification_contract/?page[number]=${page}&page[size]=${pageSize}`,
    makeFilterParams(query),
  );
};

const postGeneral = async (data) => {
  return await httpClient.post('/ct_certification_general/', data);
};

const getGeneral = async (id) => {
  return await httpClient.get(`/ct_certification_general/${id}`);
};

export {
  contractorsTable,
  contractsTable,
  getContractor,
  getContractDetails,
  certificatesTable,
  post,
  get,
  generalCertificatesTable,
  generalCertificatesOrganizations,
  generalCertificatesContractTable,
  postGeneral,
  getGeneral,
};
